<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <div v-if="false" style="text-align: right;margin: 8px 0 12px 0;">
      <el-button @click="handleQuit()" size="small">取消</el-button>
      <el-button type="primary" @click="handleSubmitForm('1')" size="small"
        >保存</el-button
      >
    </div>
    <el-form
      :model="form"
      ref="form"
      label-width="150px"
      :rules="rules"
      class="product-form"
    >
      <div class="t_plane self_el_item_form">
        <div class="pl_til">
          {{ user.userType == "00" ? "审核底板" : "购买独有底板" }}
        </div>
        <div class="pl_content">
          <el-form-item label="产品名称：" style="margin-top: 20px">
            <span style="margin: 0 8px 0 0;">
              {{ currentProduct.proName }}
            </span>
            <el-button
              v-if="viewType == 'edit' || viewType == ''"
              @click="handleChooseProduct"
              size="small"
              type="primary"
              >选择产品</el-button
            >
          </el-form-item>
          <el-form-item
            label="颜色："
            style="margin-top: 20px"
            v-if="currentAttr.color"
          >
            <div class="sku-attr">
              <div class="sku-detail">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="key"
                  placement="top"
                  v-for="(value, key, index) in skuList"
                  :key="index"
                >
                  <a
                    :style="{ background: dictMap['color'][key] }"
                    :class="{ 'is-select': currentAttr.color === key }"
                    @click="handleSelectColor(key)"
                    class="sku-color"
                  ></a>
                </el-tooltip>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="" style="margin-top: 20px">
            <div
              v-for="(record, index) in picList"
              :key="index"
              style="overflow: hidden; display: inline-block;"
            >
             <el-popover
                placement="bottom"
                trigger="hover"
                :close-delay="closeDelay"
              >
                <div
                  slot="reference"
                  style="display: float;float:left;margin: 0 8px 0 0px;"
                >
                  <img
                      @click="handleOpenImage(record.picUrl)"
                    class="img-small"
                    style="cursor:pointer;"
                    :src="
                      `${record.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                  />
                </div>
                <img
                  class="img-big"
                  :src="
                    `${record.picUrl}?x-oss-process=image/resize,m_fill,h_300,w_300`
                  "
                  style="width: 300px;height: 300px"
                />
              </el-popover>
            </div>
          </el-form-item>

          <el-form-item label="底板效果图：" style="margin-top: 20px">
            <el-upload
              v-if="viewType == 'edit' || viewType == ''"
              ref="upload"
              drag
              action="#"
              :file-list="fileList"
              :auto-upload="false"
              :before-upload="beforeUpload"
              :on-change="handleChange"
              :multiple="true"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                支持一次传多张图片，图片大小限制20M
              </div>
            </el-upload>
            <div
              v-for="(record, index) in form.picUrlList"
              :key="index"
              style="overflow: hidden; display: inline-block;"
            >
              <el-popover
                placement="bottom"
                trigger="hover"
                :close-delay="closeDelay"
              >
                <div
                  slot="reference"
                  style="display: float;float:left;margin: 0 8px 0 0px;"
                >
                  <img
                  @click="handleOpenImage(record)"
                    class="img-small"
                    style="cursor:pointer;"
                    :src="
                      `${record}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                  />
                </div>
                <img
                  class="img-big"
                  :src="
                    `${record}?x-oss-process=image/resize,m_fill,h_300,w_300`
                  "
                  style="width: 300px;height: 300px"
                />
              </el-popover>
            </div>
          </el-form-item>
          <el-form-item
            label="联系电话："
            style="margin-top: 20px"
            prop="phoneNumber"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
          >
            <el-input
              v-if="viewType == 'edit' || viewType == ''"
              v-model="form.phoneNumber"
              size="small"
            ></el-input>
            <span v-else>
              {{ form.phoneNumber }}
            </span>
          </el-form-item>
          <el-form-item
            label="微信号："
            style="margin-top: 20px"
            prop="wechat"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
          >
            <el-input
                v-if="viewType == 'edit' || viewType == ''"
              v-model="form.wechat"
              size="small"
            ></el-input>
            <span v-else>
              {{ form.wechat }}
            </span>
          </el-form-item>
          <el-form-item
            label="问题与建议描述："
            style="margin-top: 20px"
            prop="bottomDesc"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
          >
            <el-input
              v-if="viewType == 'edit' || viewType == ''"
              type="textarea"
              rows="3"
              v-model="form.bottomDesc"
              size="small"
            ></el-input>
            <span v-else>
              {{ form.bottomDesc }}
            </span>
          </el-form-item>
          <el-form-item
            v-if="viewType == 'edit' || viewType == ''"
            label=""
            style="margin-top: 20px"
          >
            <el-button type="primary" @click="handleSubmit" size="small"
              >提交</el-button
            >
            <el-button @click="handleQuit()" size="small">取消</el-button>
          </el-form-item>
        </div>
      </div>
      <div v-if="viewType == 'review'" class="remark">
        <el-form-item
          prop="bottomStatus"
          label="审核结果："
          style="margin-top: 20px"
        >
          <el-radio-group
            v-if="user.userType == '00' && viewType == 'review'"
            v-model="form.bottomStatus"
          >
            <el-radio label="02">通过</el-radio>
            <el-radio label="03">不通过</el-radio>
          </el-radio-group>
          <span v-else>{{ dictMap["bottomStatus"][form.bottomStatus] }}</span>
        </el-form-item>
        <el-form-item prop="price" label="价格：" style="margin-top: 20px">
          <el-input
            v-if="user.userType == '00' && viewType == 'review'"
            v-model="form.price"
            size="small"
            style=""
          >
          </el-input>
          <span v-else>{{ form.price }}</span>
        </el-form-item>
        <el-form-item
          v-if="user.userType == '00' && viewType == 'review'"
          label=""
          style="margin-top: 20px"
        >
          <el-button type="primary" @click="handleReview" size="small"
            >确定</el-button
          >
          <el-button @click="handleQuit()" size="small">取消</el-button>
        </el-form-item>
      </div>
    </el-form>
    <SelectProductDialog
      v-model="productDialogVisible"
      @update="handleSelectProduct"
    ></SelectProductDialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import ElRow from "element-ui/packages/row/src/row";
import CKEditor4 from '@/components/common/CKEditor'
import TreeSelect from '@/components/common/treeSelect';
import draggable from "vuedraggable"
import {mapGetters} from 'vuex'
import { getOSSToken } from "@/api/setting";
import SelectProductDialog from '@/views/customProduct/online/components/SelectProductDialog'
import { uploadFile } from "@/api/upload/upload"
import {addBottom , selectById , updateBottom , checkBottom} from '@/api/customProduct/bottom'
import {getProductDetail } from "@/api/customProduct/product";

export default {
    name: "product",
    components:{
        ElRow,
        Breadcrumb,
        CKEditor4,
        TreeSelect,
        draggable,
        SelectProductDialog
    },
    computed: {
      ...mapGetters(["dictData", "dictMap" , 'user']),
    },
    data(){
      return{
        formType: "1",
        priceModify: '',
        form:{
         bottomId: '',
         pId: '',
         bottomDesc: '',
         wechat: '',
         price: '',
         phoneNumber: '',
         picUrlList: []
        },
        rules: {
            productType: [
                {required: true, message: '请输入产品类型', trigger: 'change'},
            ],
            basicId: [
                {required: true, message: '请输入定制ID', trigger: 'blur'},
            ],
            proCode: [
                {required: true, message: '请输入产品编号', trigger: 'blur'},
            ],
            proName: [
                {required: true, message: '请输入中文名称', trigger: 'blur'},
            ],
            typeId: [
                {required: true, message: '请选择产品分类', trigger: 'blur'},
            ],
             saleForm: [
                {required: true, message: '请选择售卖方式', trigger: 'blur'},
            ],
            platId: [
                {required: true, message: '请选择产品分类', trigger: 'blur'},
            ],
            shopId: [
                {required: true, message: '请输入店铺名称', trigger: 'blur'},
            ],
            productPicAddr: [
                {required: true, message: '请选择同步产品图片地址', trigger: 'blur'},
            ],
            prodDays: [
                {required: true, message: '请输入生产时长', trigger: 'blur'},
            ],
            bottomStatus: [
                {required: true, message: '请输入生产厂商', trigger: 'blur'},
            ],
            price: [
                { required: true, message: '请输入价格', trigger: 'blur' },
            ],
        },
        productDialogVisible:false,
        currentProduct: {},
        skuList: {},
        currentAttr:{
          color: '',
        },
        picList: [],
        fileList: [],
        viewType: '',
        productDetail: {},
      }
    },
    async created() {
    },
    methods:{

      async handleSubmitForm(submitWay){
        this.$refs['form'].validate(async (valid)=>{
            if(!valid){
              return
            }
            if(this.$refs["form0"]){
              this.$refs["form0"][0].validate(async (auth)=>{
                if(!auth){
                  return
                }
                this.submit(submitWay)
              })
            }else{
               this.submit(submitWay)
            }

        })
      },
      async handleReview(){
        if(this.form.bottomStatus == '01'){
             this.msgError("请选择审核结果")
             return
        }
         this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.form.price = Number(this.form.price )
            let form = this._.pick(this.form, "bottomId","bottomStatus","price")
                checkBottom(form).then((res) => {
                  if (res.code === 200) {
                    this.msgSuccess("提交成功！")
                    if(this.user.userType == '00'){
                      this.$router.push({
                      path: '/business/sellers/bottom'
                    })
                    }else{
                      this.$router.push({
                        path: '/select/selection/model'
                      })
                    }

                  } else {
                    this.msgError("提交失败！")
                  }
                })
                .catch((err) => {
                  console.error(err)
              })
          }});
      },
      async handleSubmit(){
        let _self = this
        let imageDataArr = []
        if(_self.fileList.length == 0 && _self.form.picUrlList.length == 0){
          this.msgError('请上传底板效果图')
          return
        }
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            if (_self.fileList.length > 0) {
              for (let i = 0; i < _self.fileList.length; i++) {
                const file = _self.fileList[i]
                if (file.raw) {
                  let imageData = Object.assign({}, _self.uploadForm)
                  if (true) {
                    const { uploadFlag, fileUrl } = await uploadFile(file)
                    if (!uploadFlag) {
                      _self.msgError("上传失败！")
                      return
                    }

                    imageData.picUrl = fileUrl
                    imageData.picWidth = file.picWidth
                    imageData.picHeight = file.picHeight
                    imageData.picName = file.raw.name
                    imageData.fileSize = file.raw.size
                    imageDataArr.push(fileUrl)
                  }
                }
              }
              this.form.picUrlList = imageDataArr
            }
            if(!this.form.bottomId){
              addBottom(this.form)
              .then((res) => {
                if (res.code === 200) {
                  _self.msgSuccess("提交成功！")
                  this.$router.push({
                    path: '/select/selection/model'
                  })
                } else {
                  _self.msgError("提交失败！")
                }
              })
              .catch((err) => {
                console.error(err)
              })
            }else{
              let form = this._.pick(this.form, "pId", "bottomId","bottomDesc","wechat","phoneNumber","picUrlList")
              updateBottom(form).then((res) => {
                if (res.code === 200) {
                  _self.msgSuccess("提交成功！")
                  this.$router.push({
                    path: '/select/selection/model'
                  })
                } else {
                  _self.msgError("提交失败！")
                }
              })
              .catch((err) => {
                console.error(err)
              })
            }


          }
        });
      },
      handleQuit(){
        this.$router.go(-1)
      },
      handleChange(file, fileList) {
        this.fileList = fileList
        var reader = new FileReader()
        let _this = this
        reader.onload = function(event) {
          var txt = event.target.result
          var img = document.createElement("img")
          img.src = txt
          img.onload = function() {
            _this.fileList.map((record) => {
              if (record.uid === file.uid) {
                record.picWidth = img.width
                record.picHeight = img.height
              }
            })
          }
        }
        reader.readAsDataURL(file.raw)
      },

      getOssToken() {
        var _self = this
        getOSSToken()
        .then(function (res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      handleChooseProduct(){
        this.productDialogVisible = true
      },
      handleSelectProduct(record){
        let skuList = {}
        let defaultColor = ''
        for(let sku of record.skuList){
          let color = sku.properVal.split(':')[0]
          if(!defaultColor){
            defaultColor = color
          }
          if(!skuList[color]){
            skuList[color] = sku.picList
          }
        }
        this.currentProduct = record
        this.currentAttr.color = defaultColor
        this.skuList = skuList
        this.productDialogVisible = false
        this.form.pId = record.pId
        this.handleSelectColor(defaultColor)
      },
      handleSelectColor(color) {
        this.currentAttr.color = color
        this.picList = this.skuList[color]
      },
      beforeUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 20MB!")
      }
      return isLt2M
      },
      handleOpenImage(record){
        window.open(record, '_blank')
      }
    },
    async mounted(){
      let viewType = this.$route.query.type
      let bottomId = this.$route.query.bottomId
      let pId = this.$route.query.pId
      if(viewType) {
        this.viewType = viewType
      }
      if(bottomId){
        this.form.bottomId = bottomId
        let result = await selectById({ bottomId })
        this.form = result
        //获取产品详情
        result = await getProductDetail(result.pId)
        this.handleSelectProduct(result.data)
        this.currentProduct = result.data
        // this.fileList = this.form.picUrlList
      }
      if(pId){
        let result = await getProductDetail(pId)
        this.handleSelectProduct(result.data)
        this.currentProduct = result.data
      }
    }
  }
</script>

<style lang="scss" scoped>
.headerBorder {
  border: 1px solid darkgrey;
}
.container {
  margin-top: 15px;
}
.main {
  border: 1px solid darkgrey;
  border-top: none;
  width: 100%;
}
.el-header {
  height: 40px;
}
.inputSize {
  width: 300px;
}
.image {
  width: 88px;
  display: block;
  height: 100px;
}
.product-form {
  background: #ffffff;
  padding: 16px;
  ::v-deep .el-form-item__content {
    width: 600px;
  }

  ::v-deep .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .wd100 {
    ::v-deep .el-form-item__content {
      width: calc(100% - 150px);
    }
  }
}
.pl_til {
  background-color: #ffffff;
  border-bottom: none;
  border-left: 4px solid #4934b2;
  padding: 0 0 0 15px;
  font-size: 15px;
  color: #333333;
  font-weight: inherit;
}
.t_plane {
  border: none;
  border-radius: 0px;
}
.color-list {
  margin: 0 0 16px 0;
}
.price-set {
  font-size: 16px;
}
.sku-list {
  margin: 8px 0 0 0;
}
.pl-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}
.extra-image-ul > li,
.extra-image-ul > li {
  background: #eeeeee;
}
.sort-img-item {
  position: relative;
  width: 100px;
  height: 100px;
  display: inline-block;
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0;
  }
}

.extra-image-ul li {
  width: 100px;
  height: 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid rgb(221, 221, 221);
  position: relative;
  text-align: center;
  display: inline-block;
}
.add-image-button {
  background: #ebeef5;
}
.add-image-button > p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  width: 110%;
  font-size: 20px;
}
.item-badge {
  position: absolute;
  color: rgb(255, 165, 79);
  font-weight: bold;
  font-size: 14px;
  top: 5px;
  left: 6px;
  // -ms-transform: rotate(-35deg);
  // -webkit-transform: rotate(-35deg);
  // transform: rotate(-35deg);
  -webkit-transition: 0 0.1s ease-in;
  -moz-transition: 0 0.1s ease-in;
  -o-transition: 0 0.1s ease-in;
  transition: transform 0.1s ease-in;
  z-index: 100;
}
li .wish-product-img-ope,
li .wish-product-img-ope,
li .wish-product-img-ope {
  width: calc(100% - 8px);
  padding: 1px 4px;
  background: rgb(73, 52, 178);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
  line-height: 20px;
  text-align: left;
  font-size: 12px;
  color: #ffffff;
  .set-main {
    float: left;
    cursor: pointer;
  }
  .set-delete {
    float: right;
    cursor: pointer;
  }
}
.price-set {
  ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 16px;
  }
}
.insert-link {
  color: #4934b2;
  display: inline-block;
  width: 66px;
  .variable-select-menu {
    position: absolute;
    top: 10px;
    left: 58px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-menu li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-menu > ul > li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-select-menu > ul > li:hover .variable-pick-ul {
    display: block;
  }
}
.insert-link:hover .variable-select-menu {
  display: block;
}
.variable-select-box-text {
  color: #333333;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #4934b2;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #4934b2;
  color: #fff;
  background-color: #4934b2;
}
.text-link {
  color: #333;
}
.text-link:visited,
.text-link:hover {
  color: #333;
}
.form-remark {
  float: left;
  color: #606266;
}
.form-control {
  float: left;
  width: 500px;
}
.insert-link {
  color: #4934b2;
  display: inline-block;
  width: 66px;
}
.title {
  border-left: 4px solid #4934b2;
  padding-left: 15px;
  font-size: 16px;
  margin-bottom: 16px;
}
#main {
  background: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  .title {
    border-left: 4px solid #4934b2;
    padding-left: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .check-list {
    margin: 0 0 16px 0;
  }
  ::v-deep .el-form-item__content {
    width: 600px;
  }
  .form-title {
    line-height: 40px;
    font-size: 16px;
  }
  .form-control {
    float: left;
    width: 500px;
  }
  .form-remark {
    float: left;
    color: #606266;
  }
  .image-hint {
    color: #606266;
  }
  .extra-image-ul > li,
  .extra-image-ul > li {
    background: #eeeeee;
    img {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
    }
  }

  .extra-image-ul > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > li > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  .detail-image-ul.amazon > li .wish-product-img-ope,
  .detail-image-ul.lazada > li .wish-product-img-ope,
  .wish-product-img > li .wish-product-img-ope {
    width: calc(100% - 8px);
    padding: 1px 4px;
    background: rgb(73, 52, 178);
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 9;
    line-height: 20px;
    text-align: left;
    font-size: 12px;
    .set-main {
      float: left;
      cursor: pointer;
    }
    .set-delete {
      float: right;
      cursor: pointer;
    }
  }
  .detail-image-ul.amazon > li .wish-product-img-ope > a,
  .detail-image-ul.lazada > li .wish-product-img-ope > a,
  .wish-product-img > li .wish-product-img-ope > a {
    color: #fff;
  }
  .item-badge {
    position: absolute;
    color: rgb(255, 165, 79);
    font-weight: bold;
    font-size: 14px;
    top: -8px;
    left: 0;
    // -ms-transform: rotate(-35deg);
    // -webkit-transform: rotate(-35deg);
    // transform: rotate(-35deg);
    -webkit-transition: 0 0.1s ease-in;
    -moz-transition: 0 0.1s ease-in;
    -o-transition: 0 0.1s ease-in;
    transition: transform 0.1s ease-in;
    z-index: 1;
  }
  .add-image-button {
    font-size: 24px;
    position: relative;
  }
  .add-image-button:hover .variable-select-box {
    display: block;
  }
  .variable-select-box {
    position: absolute;
    top: 0;
    left: 100px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-box li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-box > ul > li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-select-box > ul > li:hover .variable-pick-ul {
    display: block;
  }

  .variable-pick-ul {
    position: absolute;
    top: -1px;
    left: 76px;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    z-index: 10;
    display: none;
  }
  .variable-pick-ul li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-pick-ul li {
    color: #000;
    white-space: nowrap;
  }
}
.insert-link {
  color: #4934b2;
  display: inline-block;
  width: 66px;
  .variable-select-menu {
    position: absolute;
    top: 10px;
    left: 58px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-menu li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-menu > ul > li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-select-menu > ul > li:hover .variable-pick-ul {
    display: block;
  }
}
.insert-link:hover .variable-select-menu {
  display: block;
}
.variable-select-box-text {
  color: #333333;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #4934b2;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #4934b2;
  color: #fff;
  background-color: #4934b2;
}
.text-link {
  color: #333;
}
.text-link:visited,
.text-link:hover {
  color: #333;
}
.form-label {
  display: inline-block;
  position: relative;
  line-height: 20px;
}
.field-name {
  position: absolute;
  right: 0;
  text-align: right;
  top: 20px;
  line-height: 20px;
}
.sku-attr {
  overflow: hidden;
  padding: 0 0 0 8px;
  .sku-name {
    margin: 0 32px 0 0;
    float: left;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;

    width: calc(100% - 100px);
  }
}
.sku-color {
  margin: 0 8px 0 0;
  border: 1px solid #aaaaaa;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  transition: all 0.5s ease-in-out;
  border: 3px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
}
.sku-size {
  color: #333;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  text-transform: capitalize;
  display: inline-block;
  margin: 0;
  min-width: 30px;
  overflow: hidden;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 7px;
  transition: all 0.5s ease-in-out;
  padding: 0 12px;
  margin: 0 8px 5px 0;

  border: 3px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
  cursor: pointer;
  box-sizing: border-box;
}

.is-select {
  border: 3px solid #f25551;
  box-shadow: none;
}
.remark {
  margin: 8px 0 0 0;
  border-top: 1px solid #aaaaaa;
}
 .img-small {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    padding: 1px;
    border: 1px solid #ccc;
  }
   .img-small:hover{
       border: 1px solid #f25551;
   }
</style>
